import { render, staticRenderFns } from "./AddUnit.vue?vue&type=template&id=624b9330&scoped=true&"
import script from "./AddUnit.vue?vue&type=script&lang=js&"
export * from "./AddUnit.vue?vue&type=script&lang=js&"
import style0 from "./AddUnit.vue?vue&type=style&index=0&id=624b9330&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b9330",
  null
  
)

export default component.exports